import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface TopicPageNotHelpfulEventProperties {
  department_slug: string
  topic?: string
}

export class TopicPageNotHelpfulEvent extends Event<TopicPageNotHelpfulEventProperties> {
  static displayName = 'Topic Page Not Helpful'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
